"use client";
import React, { useState, useRef, useEffect } from "react";
import ICON_ARROW_DOWN from "@/public/arrow_down.svg";
import ICON_ARROW_DOWN_DARK from "@/public/arrow_down_dark.svg";
import "./popupButtonDesktop.scss";
import { Image } from '@/lib/target';
import {useSelector} from "react-redux";

const PopupButton = ({ data, handleChange, type='other', additionalClass="" }) => {

  const bookmarker = useSelector(
    (state) => state.bookmakerReducer
  );
  const [isVisible, setIsVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState( type === 'other' ?  data[0].name : data.filter(bmk => bmk.value === bookmarker)[0].name);
  const popoverRef = useRef(null);

  const togglePopover = () => {
    setIsVisible(!isVisible);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsVisible(false);
  };

  const handleClickOutside = (event) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };


  }, []);

  return (
    <div className="relative inline-block w-max">
      <button
        onClick={togglePopover}
        className={`flex w-full items-center justify-between gap-1 pr-1 pl-2.5 px-2 py-1 font-montserrat text-x1s dark:text-stroke-o3 bg-[#FFFFFF] dark:bg-league-gray-dark rounded-md focus:outline-none h-[21px] font-bold text-dark-gray ${additionalClass}`}
      >
          {selectedOption}
          <Image src={ICON_ARROW_DOWN} className="block dark:hidden w-2.5 h-2.5" />
          <Image src={ICON_ARROW_DOWN_DARK} className="hidden dark:block w-2.5 h-2.5" />
      </button>

      {isVisible && (
        <div
          className="absolute top-full right-0 w-[10rem] mt-1 z-40 bg-white rounded-lg shadow-lg"
          ref={popoverRef}
        >
          <div className="text-gray-700 dark:text-stroke-o3">
            <div className="bg-white-half dark:bg-league-white rounded-lg p-2">
            {data.length > 0 &&
              data.map((item, index) => (
                <div
                  key={index}
                  className={` font-medium cursor-pointer p-2 hover:bg-gray-200 rounded-lg ${index % 2 !== 0 && "bg-vr-light-gray dark:bg-league-white"
                  } hover:bg-yellow-pastel dark:hover:bg-league-gray-dark`}
                  onClick={() => {
                    handleChange(item.value)
                    handleOptionClick(item.name)
                  }}
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(PopupButton);
